import { Box, Stack, Typography } from "@mui/material";
import { default as React, useEffect, useState } from "react";
import {
    useGetSspiExamListMutation,
    useGetSspiMasterListMutation,
    useGetSspiSubjectListMutation,
    useGetSspiResponseListMutation,
} from "../../apiSlice";
import SideBar from "../Dashboard/StudentDashboard/Sidebar/SideBar";
import Breadcrumb from "../StudentBreadcrumb/Breadcrumb";
import SubjectCard from "./SubjectCard";

const StudentAssessment = () => {
    const [sspiSubjectList, setSspiSubjectList] = useState([]);
    const [sspiResponseList, setSspiResponseList] = useState([]);

    const [getSspiSubjectList] = useGetSspiSubjectListMutation();
    const [getSspiResponseList] = useGetSspiResponseListMutation();

    const currentDate = new Date();
    console.log("currentDate ==== ", currentDate);

    useEffect(() => {
        const fetchData = async () => {
            try {
                /**
                 * SSPI Subject List
                 */
                const subjectList = await getSspiSubjectList();
                const responseList = await getSspiResponseList();

                setSspiSubjectList(subjectList.data);
                setSspiResponseList(responseList.data);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <SideBar />
            <Box
                sx={{
                    flexGrow: 1,
                    position: "relative",
                    width: "calc(100vw - 60px)",
                    padding: "20px",
                    height: "100vh",
                    overflowY: "scroll",
                    left: "60px",
                    backgroundColor: "#F8F9FD",
                }}
            >
                <Box>
                    <Breadcrumb />
                </Box>
                {/* Initial Assessment */}
                <Box
                    bgcolor="white"
                    padding="20px"
                    borderRadius="12px"
                    marginBottom={2}
                >
                    <Stack>
                        <Typography
                            variant="h5"
                            color="black"
                            sx={{
                                marginBottom: "10px",
                            }}
                        >
                            Initial Assessment
                        </Typography>
                        <Box
                            sx={{
                                padding: "10px 0",
                                width: "100%",
                            }}
                        >
                            <Stack gap={2}>
                                {sspiResponseList
                                    .filter((exam) => exam.sspiExamId === 1)
                                    .map((exam, idx) => {
                                        const sspiStartDate = new Date(
                                            exam.sspiStartDate
                                        );
                                        const sspiEndDate = new Date(
                                            exam.sspiEndDate
                                        );

                                        console.log(
                                            "exam.sspiStartDate ==== ",
                                            sspiStartDate
                                        );
                                        console.log(
                                            "currentDate ====== ",
                                            currentDate
                                        );
                                        console.log(
                                            "exam.sspiEndDate ==== ",
                                            sspiEndDate
                                        );
                                        console.log(
                                            "start and current",
                                            sspiStartDate <= currentDate
                                        );
                                        console.log(
                                            "current and end",
                                            currentDate <= sspiEndDate
                                        );
                                        console.log(
                                            "date condition ====== ",
                                            sspiStartDate <= currentDate &&
                                                currentDate <= sspiEndDate
                                        );

                                        return (
                                            <SubjectCard
                                                key={idx}
                                                subjectId={exam?.sspiSubjectId}
                                                masterId={exam?.sspiMasterId}
                                                disabled={
                                                    // exam?.sspiExamId == 1
                                                    sspiStartDate <=
                                                        currentDate &&
                                                    currentDate <= sspiEndDate
                                                        ? exam?.sspiIsAttempted
                                                        : true
                                                }
                                                title={
                                                    sspiSubjectList.filter(
                                                        (sub) =>
                                                            sub.sspiSubjectId ===
                                                            exam.sspiSubjectId
                                                    )[0].sspiSubject1
                                                }
                                            />
                                        );
                                    })}
                            </Stack>
                        </Box>
                    </Stack>
                </Box>

                {/* Half Assessment */}
                <Box
                    bgcolor="white"
                    padding="20px"
                    borderRadius="12px"
                    marginBottom={2}
                >
                    <Stack>
                        <Typography
                            variant="h5"
                            color="black"
                            sx={{
                                marginBottom: "10px",
                            }}
                        >
                            Half Assessment
                        </Typography>
                        <Box
                            sx={{
                                padding: "10px 0",
                                width: "100%",
                            }}
                        >
                            <Stack gap={2}>
                                {sspiResponseList
                                    .filter((exam) => exam.sspiExamId === 2)
                                    .map((exam, idx) => {
                                        const sspiStartDate = new Date(
                                            exam.sspiStartDate
                                        );
                                        const sspiEndDate = new Date(
                                            exam.sspiEndDate
                                        );

                                        return (
                                            <SubjectCard
                                                key={idx}
                                                subjectId={exam?.sspiSubjectId}
                                                disabled={
                                                    sspiStartDate <=
                                                        currentDate &&
                                                    currentDate <= sspiEndDate
                                                        ? exam?.sspiIsAttempted
                                                        : true
                                                }
                                                title={
                                                    sspiSubjectList.filter(
                                                        (sub) =>
                                                            sub.sspiSubjectId ===
                                                            exam.sspiSubjectId
                                                    )[0].sspiSubject1
                                                }
                                            />
                                        );
                                    })}
                            </Stack>
                            {/* {sspiSubjectList.length > 0 ? (
                                    <Stack gap={2}>
                                        {sspiSubjectList?.map(
                                            (subject, idx) => (
                                                <SubjectCard
                                                    key={idx}
                                                    subjectId={
                                                        subject?.sspiSubjectId
                                                    }
                                                    disabled={
                                                        exam?.sspiExamId == 1
                                                            ? true
                                                            : false
                                                    }
                                                    title={
                                                        subject?.sspiSubject1
                                                    }
                                                />
                                            )
                                        )}
                                    </Stack>
                                ) : (
                                    <Typography
                                        variant="subtitle1"
                                        color="secondary"
                                    >
                                        No Subjects Listed for Assessment
                                    </Typography>
                                )} */}
                        </Box>
                    </Stack>
                </Box>

                {/* Final Assessment */}
                <Box
                    bgcolor="white"
                    padding="20px"
                    borderRadius="12px"
                    marginBottom={2}
                >
                    <Stack>
                        <Typography
                            variant="h5"
                            color="black"
                            sx={{
                                marginBottom: "10px",
                            }}
                        >
                            Final Assessment
                        </Typography>
                        <Box
                            sx={{
                                padding: "10px 0",
                                width: "100%",
                            }}
                        >
                            <Stack gap={2}>
                                {sspiResponseList
                                    .filter((exam) => exam.sspiExamId === 3)
                                    .map((exam, idx) => {
                                        const sspiStartDate = new Date(
                                            exam.sspiStartDate
                                        );
                                        const sspiEndDate = new Date(
                                            exam.sspiEndDate
                                        );

                                        return (
                                            <SubjectCard
                                                key={idx}
                                                subjectId={exam?.sspiSubjectId}
                                                disabled={
                                                    sspiStartDate <=
                                                        currentDate &&
                                                    currentDate <= sspiEndDate
                                                        ? exam?.sspiIsAttempted
                                                        : true
                                                }
                                                title={
                                                    sspiSubjectList.filter(
                                                        (sub) =>
                                                            sub.sspiSubjectId ===
                                                            exam.sspiSubjectId
                                                    )[0].sspiSubject1
                                                }
                                            />
                                        );
                                    })}
                            </Stack>
                        </Box>
                    </Stack>
                </Box>
            </Box>
        </>
    );
};

export default StudentAssessment;
